






























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Card from '@/stories/utils/card.vue'


@Component({
  components: {
    Card,
  }
})
export default class StorybookTooltipIcon extends Vue {}
